import { cn } from "@/lib/utils";

type PorscheLogoPropsT = {
  className?: string;
  fill?: string;
  width?: number | string;
  height?: number | string;
};

export default function PorscheLogo({
  className,
  fill = "currentColor",
  width = 90,
  height = 20,
}: PorscheLogoPropsT) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="PORSCHE"
      x="0"
      y="0"
      width={width}
      height={height}
      viewBox="0 0 90 20"
      className={cn(className)}
    >
      <path
        d="M10,4.4c1,0,1.5-0.5,1.5-1.5V1.5C11.5,0.5,11,0,10,0H0v6h1.4V4.4H10z M10.2,1.6v1.3c0,0.2-0.1,0.2-0.2,0.2H1.4V1.3h8.6  C10.1,1.3,10.2,1.4,10.2,1.6z M14.7,6c-1,0-1.5-0.5-1.5-1.5v-3c0-1,0.5-1.5,1.5-1.5h8.3c1,0,1.5,0.5,1.5,1.5v3c0,1-0.5,1.5-1.5,1.5  H14.7z M22.9,4.7c0.2,0,0.2-0.1,0.2-0.2V1.6c0-0.2-0.1-0.2-0.2-0.2h-8.1c-0.2,0-0.2,0.1-0.2,0.2v2.9c0,0.2,0.1,0.2,0.2,0.2H22.9z   M36.4,4c0.8,0.3,1.4,1.1,1.4,2h-1.4c0-1.1-0.5-1.6-1.6-1.6h-7.2V6h-1.4V0h10c1,0,1.5,0.5,1.5,1.5v1C37.8,3.4,37.3,3.9,36.4,4z   M36.2,3.1c0.2,0,0.2-0.1,0.2-0.2V1.6c0-0.2-0.1-0.2-0.2-0.2h-8.6v1.8H36.2z M39.4,1.5c0-1,0.5-1.5,1.5-1.5h9.8v1.1H41  c-0.2,0-0.2,0.1-0.2,0.2v0.8c0,0.2,0.1,0.2,0.2,0.2h8.4c1,0,1.5,0.5,1.5,1.5v0.6c0,1-0.5,1.5-1.5,1.5h-9.8V4.9h9.7  c0.2,0,0.2-0.1,0.2-0.2V3.8c0-0.2-0.1-0.2-0.2-0.2h-8.4c-1,0-1.5-0.5-1.5-1.5V1.5z M52.7,1.5c0-1,0.5-1.5,1.5-1.5h9.6v1.3h-9.5  c-0.2,0-0.2,0.1-0.2,0.2v2.9c0,0.2,0.1,0.2,0.2,0.2h9.5V6h-9.6c-1,0-1.5-0.5-1.5-1.5V1.5z M76.3,0v6H75V3.7h-8.1V6h-1.4V0h1.4v2.3  H75V0H76.3z M79.5,1.1v1.3H90v1.1H79.5v1.3H90V6H78.1V0H90v1.1H79.5z"
        fill={fill}
        transform="translate(0, 7)"
      />
    </svg>
  );
}
